import NamaPlace from "@/utils/presenters/NamaPlace.ts";
import PlaceTokens from "@/utils/constants/PlaceTokens.ts";

export default class WelcomePlace extends NamaPlace {
  get dashBoardId(): string | undefined {
    return this.query[PlaceTokens.PRM_DASHBOARDID];
  }

  set dashBoardId(value: string | undefined) {
    this.query[PlaceTokens.PRM_DASHBOARDID] = value;
  }

  get importObjects(): string | undefined {
    return this.query[PlaceTokens.PRM_IMPORT_OBJECTS];
  }

  set importObjects(value: string | undefined) {
    this.query[PlaceTokens.PRM_IMPORT_OBJECTS] = value;
  }

  get flowId(): string | undefined {
    return this.query[PlaceTokens.PRM_FLOW_ID];
  }

  set flowId(value: string | undefined) {
    this.query[PlaceTokens.PRM_FLOW_ID] = value;
  }

  get flowTargetId(): string | undefined {
    return this.query[PlaceTokens.PRM_FLOW_TARGET_ID];
  }

  set flowTargetId(value: string | undefined) {
    this.query[PlaceTokens.PRM_FLOW_TARGET_ID] = value;
  }

  get flowTargetType(): string | undefined {
    return this.query[PlaceTokens.PRM_FLOW_TARGET_TYPE];
  }

  set flowTargetType(value: string | undefined) {
    this.query[PlaceTokens.PRM_FLOW_TARGET_TYPE] = value;
  }

  get crossFilters(): string | undefined {
    return this.query[PlaceTokens.PRM_CROSS_FILTERS];
  }

  set crossFilters(value: string | undefined) {
    this.query[PlaceTokens.PRM_CROSS_FILTERS] = value;
  }

  get subDashboardId(): string | undefined {
    return this.query[PlaceTokens.PRM_SUB_DASHBOARD];
  }

  set subDashboardId(value: string | undefined) {
    this.query[PlaceTokens.PRM_SUB_DASHBOARD] = value;
  }
}
